var exports = {
  "X7": "UserProfileBadges.module__containerModal___ZThTaV",
  "j4": "UserProfileBadges.module__containerModalMobile___ZThTaV",
  "pP": "UserProfileBadges.module__containerModalDesktop___ZThTaV",
  "RS": "UserProfileBadges.module__containerPopout___ZThTaV",
  "Qk": "UserProfileBadges.module__badgeMobile___ZThTaV",
  "EJ": "UserProfileBadges.module__badgeDesktop___ZThTaV",
  "SI": "UserProfileBadges.module__captionBadge___ZThTaV",
  "Kd": "UserProfileBadges.module__captionBadgeMobile___ZThTaV",
  "eA": "UserProfileBadges.module__captionBadgeDesktop___ZThTaV",
  "nf": "UserProfileBadges.module__link___ZThTaV",
  "$J": "UserProfileBadges.module__linkButton___ZThTaV",
  "zH": "UserProfileBadges.module__details___ZThTaV",
  "i5": "UserProfileBadges.module__detailsArt___ZThTaV",
  "x2": "UserProfileBadges.module__detailsTitle___ZThTaV",
  "L4": "UserProfileBadges.module__detailsLine___ZThTaV",
};

module.exports = exports;
